export default __webpack_public_path__ + "static/flame-3ab61ef2ee426bfe2ec26da9d2ad96f8.png";